import { useMemo } from 'react';
import { useProfileContext } from '../../Contexts/ProfileContext';

export const useHasServices = () => {
  const { partnerProfile, services = [] } = useProfileContext();

  return useMemo(() => {
    const servicesList = services.flatMap((category) => category.services);
    const foundServices = (partnerProfile.services?.values || [])
      .map(({ id }) => servicesList.find((service) => service?.id === id))
      .filter(Boolean);
    return foundServices.length > 0;
  }, [partnerProfile.services?.values, services]);
};
